<div class="loader-container">
    @if (!loader.showLogo()) {
        <div class="loader-content">
            <mat-progress-spinner [diameter]="50" [mode]="loader.mode() === 'determinate' ? 'determinate' : 'indeterminate'" [value]="loader.value()"></mat-progress-spinner>
            @if (loader.mainMessage()) {
                <div class="loader-caption loader-caption-main">{{ loader.mainMessage() }}</div>
            }
            @if (loader.otherMessage()) {
                <div class="loader-caption">{{ loader.otherMessage() }}</div>
            }
        </div>
    } @else {
        <div class="loader-content">
            <div class="tw-flex tw-flex-col">
                <img [src]="'assets/images/tilby/' + loader.logoUrl()" class="loader-logo" alt="">
                <mat-progress-bar color="primary" [mode]="loader.mode()" [value]="loader.value()" [bufferValue]="0"></mat-progress-bar>
            </div>
            @if (loader.updateMode()) {
                <div class="loader-caption loader-caption-main">{{ 'UPDATER.UPDATING_APP' | translate }}</div>
            } @else {
                <div class="loader-caption loader-caption-main">{{ 'APPLICATION.LOADER.LOADING_APP' | translate: { message: loader.mainMessage() } }}</div>
            }
            @if (loader.otherMessage()) {
                <div class="loader-caption">{{ loader.otherMessage() }}</div>
            }
            <div class="logo-zucchetti">
                <img src="assets/images/tilby/Zuc_Orizz_B.svg" alt="Logo Zucchetti">
            </div>
        </div>
    }
</div>
